<template>
  <a-modal
    :visible="visible.batchAddNutList"
    @ok="ok"
    :bodyStyle="{ padding: '10px' }"
    :destroyOnClose="true"
    :forceRender="true"
    @cancel="toggleVisible('batchAddNutList')"
    width="900px"
  >
    <span class="title" slot="title">添加营养指标</span>
    <a-spin :spinning="addLoading">
      <a-space style="padding:0 0 10px">
        <a-input-search
          :allowClear="true"
          size="small"
          v-model="filterData.nutritionName"
          @change="inputChange"
          placeholder="指标名称"
          style="width: 220px"
          @search="onSearch"
        />
        <base-list-select
          style="width:300px"
          :value="rawType"
          @change="typeChange"
          placeholder="选择指标类型"
          category="nutritiontarget"
        />
      </a-space>
      <a-table
        :columns="columns"
        bordered
        :scroll="{ x: 870, y: 450 }"
        :row-selection="{ selectedRowKeys, onChange: onSelectChange }"
        :loading="nutLoading"
        :data-source="list.records"
        :row-key="record => record.id"
        :pagination="false"
      />
    </a-spin>
  </a-modal>
</template>
<script>
import BaseListSelect from "../../Nhf/Compound/select/BaseListSelect.vue";
import { formulaMixins } from "../unitls";
export default {
  components: { BaseListSelect },
  props: ["hidden","relist"],
  mixins: [formulaMixins],
  data() {
    return {
      nutLoading: false,
      filterData: {},
      list: {
        records: []
      },
      rawType: [],
      addLoading: false,
      columns: [
        {
          dataIndex: "name",
          title: "指标名称",
          width: 110
        },
        {
          dataIndex: "fullName",
          title: "全称"
        },
        {
          dataIndex: "typeName",
          title: "类型",
          width: 200
        },
        {
          dataIndex: "unit",
          title: "单位",
          width: 80
        }
      ]
    };
  },

  watch: {
    "visible.batchAddNutList"(val) {
      val ? this.getList() : this.restList();
    }
  },

  methods: {
    inputChange({ target }) {
      this.getList({
        nutritionName: target.value
      });
    },

    async batchUpdate() {
      return this.fetchPost({
        actions: this.batchAddFormulaNutritionUpdateConfirm,
        loading: "addLoading",
        data: {
          taskFormulaIds: this.formulaSelectedRows.map(i => i.id).join(),
          nutritionIds: this.selectedRows.map(i => i.id).join()
        }
      });
    },

    async ok() {
      console.log(this.relist,this.selectedRows)
      if (this.selectedRows.length) {
        if(this.relist.some(i => this.selectedRows.some(item => item.id === i.id))){
          this.$message.warn('已添加的营养指标，不能重复添加')
        } else {
          const res = await this.batchUpdate()
          this.toggleVisible("batchAddNutList")
          this.$emit("ok", res);
        }
      } else {
        this.$message.warn("选择需要添加的营养指标")
      }
    },

    getList(arg = {}) {
      return this.fetchGet({
        actions: this.selectAddFormulaTaskNutritionByCond,
        isList: true,
        name: "list",
        loading: "nutLoading",
        data: {
          taskFormulaIds: this.formulaSelectedRows.map(i => i.id).join(),
          nutritionIds:this.relist.map(i => i.nutritionId).join(),
          size: 2000,
          ...this.filterData,
          ...arg
        }
      });
    },

    restList() {
      this.filterData = {};
      this.rawType = [];
      this.cleanSelect();
    },

    onSearch(nutritionName) {
      this.getList({
        nutritionName
      });
    },

    typeChange(val) {
      this.rawType = val;
      const typeId = [...val].pop();
      this.filterData.typeId = typeId;
      this.getList({
        typeId
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;
  b {
    font-size: 12px;
    font-weight: normal;
    color: #999;
    margin-left: 10px;
  }
}
</style>
